<template>
    <div class="counter-wrapper text-center text-white">
        <div class="count-items">{{ timeLeft.days }}<span class="d-block">days</span></div>
        <div class="count-items px-2">:</div>
        <div class="count-items">{{ timeLeft.hours }}<span class="d-block">hours</span></div>
        <div class="count-items px-2">:</div>
        <div class="count-items">{{ timeLeft.minutes }}<span class="d-block">minutes</span></div>
        <div class="count-items px-2">:</div>
        <div class="count-items">{{ timeLeft.seconds }}<span class="d-block">seconds</span></div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        targetTime: new Date('2024-09-02T23:59:59').getTime(), // Set your target time here
        timeLeft: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        },
        intervalId: null,
      };
    },
    mounted() {
      this.startCountdown();
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    methods: {
      startCountdown() {
        this.updateTimeLeft();
        this.intervalId = setInterval(this.updateTimeLeft, 1000);
      },
      updateTimeLeft() {
        const now = new Date().getTime();
        const distance = this.targetTime - now;
  
        if (distance < 0) {
          clearInterval(this.intervalId);
          this.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        } else {
          this.timeLeft.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          this.timeLeft.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          this.timeLeft.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          this.timeLeft.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .countdown {
    text-align: center;
    font-size: 2em;
  }
  </style>
  